module.exports = __webpack_public_path__ + "static/media/ois1.fff7a5be.png";